module.exports = "/React/dist/73b1716b310242ee443dcbabf8bac4de.jpg";